module.exports = __webpack_public_path__ + "hyperion-v2-static/fonts/TruenoSBdIt.3ee01de9.otf";